import { toast } from "react-toastify";
import config from '../../Config/config.json';
import { LogOut } from "../../Redux/Actions/index.js";
import { store } from "../../Redux/Store/index.js";
import { EquipamentRequests } from "./request.ts";
import i18n from "../../Config/i18n.js";
import { handleError } from "../../util/errorHandler.js";

/**
 * Classe para gerenciamento da página de equipamentos
 */
export class EquipamentTypesServices {
    constructor() {
        this.equipamentRequests = new EquipamentRequests();
    }

    // Busca lista de tipos de equipamentos
    async getAllEquipmentTypes(search, page){
        try {
            const response = await this.equipamentRequests.getAllEquipmentTypes(search, page);
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return false;
        }
    }

    // Busca um tipo de equipamento
    async getEquipmentType(id){
        try {
            const response = await this.equipamentRequests.getEquipmentTypes(id);
            return response.data;
        } catch (error) {
            handleError(error, { theme: config.theme });
            return false;
        }
    }

    // Edita um tipo de equipamento
    async editEquipmentType (id, data){
        try {
            const response = await this.equipamentRequests.editEquipmentType(id, data);
            toast(i18n.t('message.equipment-type-service.edit-equipment-type'), {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            return response;
        } catch (error) {
            handleError(error, { theme: config.theme });
            return false;
        }
    }

    // Cria um novo tipo de equipamento
    async SaveEquipmentType (data){
        try {
            const response = await this.equipamentRequests.CreateEquipmentType(data);
            toast(i18n.t('message.equipment-type-service.save-equipment-type'), {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            return response;
        } catch (error) {
            handleError(error, { theme: config.theme });
            return false;
        }
    }

    async deleteEquipmentType(id, navigate){
        try {
            const response = await this.equipamentRequests.deleteEquipmentType(id);
            toast(i18n.t('message.equipment-type-service.delete-equipment-type'), {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            navigate('/adm/tipos-equipamentos');
            return response;
        } catch (error) {
            handleError(error, { theme: config.theme });
            return false;
        }
    }
}